import { onGetMasterpassForMobileRequest } from 'Stores/CreditCardTransactions';
import { generateLanguageParam, MasterPassTokenEnum } from 'Utils';
import { toMasterpassVersion } from 'Utils/Masterpass';
import { FormErrorWrapper, MasterPassIcon } from 'Components';
import { mobileMasterpassConnectNormalize } from 'Normalize';
import { onInıtDataRequest, setLanguage } from 'Stores/App';
import { Typography, Box, Button } from '@material-ui/core';
import { fontSizes, gutters } from 'Theme/Variables';
import { useLocalization, useQuery, useMobileMasterpassVersion } from 'Hooks';
import { FC, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { formNames } from 'Config';

import i18n from 'i18n';

import './MobileMasterpassConnect.scss';
import { useHistory } from 'react-router';
import { routePath } from 'Navigator/routes';
type MasterPassConnectType = {};

const MasterpassConnect: FC<MasterPassConnectType> = memo(() => {
  const dispatch = useDispatch();
  const query = useQuery();

  const { push } = useHistory();

  const msisdn = query.get('msisdn');
  const lang = query.get('lang');
  const token = query.get('token');
  const cmsLang = query.get('cmsLang');
  const referenceNo = query.get('referenceNo');
  // ⚠️ Native'in ilettiği sürüm bayrağı — açılışta bir kez store'a yazılır.
  const isVersion2ActiveParam = query.get('isVersion2Active');
  useMobileMasterpassVersion(isVersion2ActiveParam);
  /* Sürüm burada HAM parametreden çözülüyor; hook onu store'a bir effect içinde
     yazdığı için ilk render'da store henüz güncel değil. */
  const isVersion2 = toMasterpassVersion(isVersion2ActiveParam) === 'v2';
  // ⚠️ v2 hesap uçları `userId` alanına MÜŞTERİ NUMARASI bekliyor; native onu
  // WebView adresinde iletiyor. Verilmezse v2 akışı JWT'nin şifreli `UserId`
  // claim'ine düşer ve Masterpass 404 ACCOUNT_NOT_FOUND döndürür.
  // Adres çubuğundan metin gelir; payload sayı bekliyor.
  const customerNumberParam = query.get('customerNumber');
  const customerNumber = customerNumberParam ? Number(customerNumberParam) : undefined;

  const {
    web_title_add_registered_credit_card,
    web_desc_add_registered_credit_card,
    web_btn_add_registered_credit_card,
  } = useLocalization();

  useEffect(() => {
    /* ⚠️ `referenceNo` YALNIZCA v1'de zorunlu. v2'de token servisi `ReqRefNumber`
       DÖNDÜRMÜYOR, native de adrese boş gönderiyor (mobil linkMasterpass.tsx) ve
       `mobileMasterpassConnectNormalize` v2 gövdesinde bu alanı hiç kullanmıyor.
       v1'den kalan bu zorunluluk yüzünden sayfa v2'de açılır açılmaz `welcome`'a
       düşüyor, yani "kayıtlı kartlarını getir" akışı hiç başlamıyordu. */
    const isUserDataDismiss =
      !msisdn || !lang || !token || !cmsLang || (!isVersion2 && !referenceNo);

    if (isUserDataDismiss) {
      push(routePath.welcome);
    }

    if (cmsLang) {
      i18n.changeLanguage(cmsLang || '');
      dispatch(setLanguage());
      dispatch(onInıtDataRequest(generateLanguageParam()));
    }
  }, []);

  const connectUserToClient = () => {
    dispatch(
      onGetMasterpassForMobileRequest({
        TokenType: MasterPassTokenEnum.LINK,
        // ⚠️ TOKEN ÜST SEVİYEDE DE GİTMELİ. Saga yetkilendirmeyi
        // `payload?.jwt ?? payload?.token` üzerinden yapıyor (sagas.ts); token
        // yalnızca `request.data` içine konduğunda oraya hiç ulaşmıyor ve
        // v2 adaptörü yetkisiz kalıyordu — hesap bağlama akışı token'sız gidiyordu.
        jwt: token ?? '',
        CustomerNumber: customerNumber,
        request: {
  /**
   * ⚠️ v1 İÇİN ŞART — v2'yi ETKİLEMEZ.
   *
   * Saga telefonu `payload.request.phoneNumberForMobile`'dan okuyup
   * `adapter.authorize({ phone })`'a veriyor. v1'de oturum kimliğinin
   * TEK kaynağı bu: `session = { accountKey: phone, userId: phone }`
   * (V1Adapter.authorize) ve `MFS.linkCardToClient` gövdesindeki
   * `msisdn` oradan geliyor. Alan geçilmediğinde v1'de msisdn BOŞ
   * gidiyor ve bağlama başarısız oluyordu.
   *
   * v2'de `accountKey = claims.AccountKey ?? phone` — JWT claim'i
   * önce geldiği için davranış değişmez; claim gelmezse de boş yerine
   * doğru telefona düşer.
   *
   * Kart ekleme (REGISTER) dispatch'i bu alanı zaten geçiyordu;
   * v2 geçişinde yalnızca LINK dalında unutulmuş.
   */
  phoneNumberForMobile: msisdn || '',
          data: mobileMasterpassConnectNormalize({
            sendSmsLanguage: lang,
            referenceNo,
            token,
            msisdn,
          }),
        },
      })
    );
  };

  return (
    <div id="mobileMasterpassConnect">
      <FormErrorWrapper formName={formNames.masterpassConnect} resetFormOnRouteChange>
        <Box textAlign="center" fontWeight={600}>
          <MasterPassIcon height="25px" width="150px" />
        </Box>
        <Typography variant="h3">
          <Box marginTop={gutters.big} textAlign="center" fontWeight={600}>
            {web_title_add_registered_credit_card}
          </Box>
        </Typography>
        <Typography variant="body1">
          <Box fontSize={fontSizes.regular} marginTop={gutters.small} textAlign="center">
            {web_desc_add_registered_credit_card}
          </Box>
        </Typography>
        <Box
          onClick={connectUserToClient}
          marginTop={gutters.large}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); connectUserToClient(); } }}
        >
          <Button variant="contained" color="secondary" fullWidth type="submit" itemID="masterpassConnectBtnTest">
            {web_btn_add_registered_credit_card}
          </Button>
        </Box>
      </FormErrorWrapper>
    </div>
  );
});

export default MasterpassConnect;
